<template>
    <div class="dm-illustrations-manager">
        <PreviousIllustrations
            @illustrationDeleted="$emit('reloadSubmission')"
        />

        <button
            class="btn btn-success dm-btn-wizard"
            v-if="add_illustrations == false"
            @click="add_illustrations = true"
        >
            {{ translate("Add Illustrations") }}
        </button>

        <div class="mb-4" v-if="add_illustrations">
            <h5>{{ translate("Illustrations") }}</h5>

            <IllustrationsUploader
                @illustrationsUploaded="$emit('reloadSubmission')"
            />

            <button class="btn btn-light" @click="add_illustrations = false">
                {{ translate("Cancel") }}
            </button>
        </div>
    </div>
</template>

<script>
import IllustrationsUploader from "./partials/IllustrationsUploader.vue";
import PreviousIllustrations from "./partials/PreviousIllustrations.vue";

export default {
    components: { IllustrationsUploader, PreviousIllustrations },

    emits: ["reloadSubmission"],

    data() {
        return {
            add_illustrations: false,
        };
    },
};
</script>
